export default __webpack_public_path__ + "static/media/strategy-tip-for-your-business.19848825.jpg";